import React from 'react';
import './EventsModal.css';

const EventsModal = ({ isOpen, onClose, onContactClick }) => {
  if (!isOpen) return null;

  return (
    <div className="events-overlay" onClick={onClose}>
      <div className="events-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="events-header">
          <h2 className="events-title">Eventos FIORI</h2>
          <p className="events-subtitle">Convertimos momentos en recuerdos inolvidables</p>
        </div>

        <div className="events-body">
          <section className="events-section">
            <h3>Nuestra Especialidad</h3>
            <p>Creamos atmósferas únicas diseñadas bajo nuestra filosofía de <strong>dar con sentido</strong>. No solo decoramos, damos vida a tu visión.</p>
            <div className="event-types">
              <span>🌸 Bodas</span>
              <span>🎓 Grados</span>
              <span>💼 Corporativos</span>
              <span>🎂 Aniversarios</span>
            </div>
          </section>

          <section className="events-section">
            <h3>¿Qué ofrecemos?</h3>
            <ul className="events-list">
              <li><strong>Diseño Floral:</strong> Arreglos exclusivos para cada espacio.</li>
              <li><strong>Ambientación:</strong> Selección de texturas y colores con propósito.</li>
              <li><strong>Asesoría:</strong> Te acompañamos en cada detalle de la elección.</li>
            </ul>
          </section>

          <section className="events-process">
            <h3>Tu evento en 3 pasos:</h3>
            <div className="process-steps">
              <div className="step">
                <span className="step-num">1</span>
                <p><strong>Consulta</strong></p>
              </div>
              <div className="step">
                <span className="step-num">2</span>
                <p><strong>Diseño</strong></p>
              </div>
              <div className="step">
                <span className="step-num">3</span>
                <p><strong>Realización</strong></p>
              </div>
            </div>
          </section>
        </div>

        <div className="events-footer">
          {/* Este botón disparará la redirección a WhatsApp definida en el Navbar */}
          <button className="events-cta-btn" onClick={onContactClick}>
            💬 Cotizar por WhatsApp
          </button>
          <button className="events-close-link" onClick={onClose}>
            Cerrar
          </button>
        </div>

      </div>
    </div>
  );
};

export default EventsModal;